import React from 'react';
import './Header.css';
import AppBar from "@material-ui/core/AppBar";
import InfoBlock from "../InfoBlock/InfoBlock";
import Status from "../Status/Status";
import AgentMenu from "./agentMenu/agentMenu";
import IconButton from "@material-ui/core/IconButton";
import HomeIcon from '@material-ui/icons/Home';
import PieChartIcon from "@material-ui/icons/PieChartOutlined";
import Tooltip from "@material-ui/core/Tooltip";

const Header = props => {
    const {stats, info, onOnlineToggle, history} = props;
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleMenu=(event)=> {
        setAnchorEl(event.currentTarget);
    };

    const handleClose=()=> {
        setAnchorEl(null);
    };

    const handleHomeClick = () => {
        // If we have a selected chat, we need to close it first
        if (props.selectedChatId) {
            // This will trigger the CHAT_SELECTED_CLOSED action
            history.push('/');
        } else if (props.showStats) {
            // If we're already on home and statistics are open, close them
            props.toggleChatStatisticsVisibility({value: false});
        } else {
            // Just go home
            history.push('/');
        }
    };

    const handlePendingBlockClick = () => {
        props.setActiveTab('pending');
        props.fetchPendingChats();
        history.push('/');
    };

    const handleHistoryBlockClick = () => {
        props.setActiveTab('history');
        props.fetchHistoryChats({ sendBody: { page: 1 } });
        history.push('/');
    };

    const handleStatisticsClick = () => {
        if (props.selectedChatId) {
            // If viewing a chat, go to home page and show statistics
            history.push('/');
            if (props.toggleChatStatisticsVisibility && !props.showStats) {
                props.toggleChatStatisticsVisibility({value: true});
            }
        } else {
            // If on home page, just toggle statistics visibility
            if (props.toggleChatStatisticsVisibility) {
                props.toggleChatStatisticsVisibility({value: !props.showStats});
            }
        }
    };

    return (
        <React.Fragment>
            {stats ?
                <AppBar position="static" className='headerAgent'>
                    <div className="headerLeft">
                        <IconButton 
                            color="inherit" 
                            aria-label="home" 
                            onClick={handleHomeClick}
                            size="small"
                        >
                            <HomeIcon />
                        </IconButton>
                        <Tooltip title={!props.showStats ? props.helpTextOpenStats : props.helpTextCloseStats} placement="bottom">
                            <IconButton
                                color="inherit"
                                aria-label="statistics"
                                onClick={handleStatisticsClick}
                                size="small"
                                className={props.showStats ? 'statisticsActive' : ''}
                            >
                                <PieChartIcon />
                            </IconButton>
                        </Tooltip>
                    </div>
                    <div className="headerCenter">
                        <InfoBlock styleNumber='h6' number={stats.onHold} text='Αναμονή' onClick={handlePendingBlockClick}/>
                        <InfoBlock styleNumber='h6' number={stats.completedToday} text='Σήμερα' onClick={handleHistoryBlockClick}/>
                        <InfoBlock styleNumber='h6' number={stats.completedYesterday} text='Χθες' onClick={handleHistoryBlockClick}/>
                        <InfoBlock styleNumber='h6' number={stats.completedTotal} text='Σύνολο' onClick={handleHistoryBlockClick}/>
                    </div>
                    <div className="headerRight">
                        <Status
                            agentName={`${info.firstname} ${info.lastname}`}
                            onOnlineToggle={onOnlineToggle}
                            isAvailable={info.isAvailable}
                        />
                        <AgentMenu
                            handleMenu={handleMenu}
                            handleClose={handleClose}
                            anchorEl={anchorEl}
                            open={open}
                        />
                    </div>
                </AppBar>
                :null}
        </React.Fragment>
    );
}

export default Header;
